import clsx from "clsx";
import { activatePrintE2ETesting } from "core/model/utils/featureFlags";
import { isPrintMode } from "core/model/utils/urls";
import { Title } from "ds_legacy/materials/typography";
import { useTranslations } from "translations";

export default function PrintOverlay() {
  const translations = useTranslations();
  const isPrint = isPrintMode();

  if (!isPrint) return null;

  return (
    <div
      className={clsx(
        "fixed z-[100] flex h-full w-full flex-1 flex-col items-center justify-center bg-white print:opacity-0",
        { "opacity-0": isPrint && activatePrintE2ETesting() },
      )}
    >
      <Title bold>{translations.general.printingPleaseWait}</Title>
    </div>
  );
}
